// The gateway resolves the immutable harness profile from this registry ID.
// Never choose a backend endpoint or infer a course's profile in the browser.
export function createCourseClient(model, fetcher = fetch) {
  async function request(path, init) {
    const response = await fetcher(`/api/harness/${path}?model=${encodeURIComponent(model)}`, init);
    const data = await response.json();
    if (!response.ok) throw new Error(data.error || data.detail || `HTTP ${response.status}`);
    return data;
  }
  const coursePath = (id) => `course/${encodeURIComponent(id)}`;
  return {
    list: () => request("courses"),
    get: (id) => request(coursePath(id)),
    session: (id, k) => request(`${coursePath(id)}/session/${k}`),
    remove: (id) => request(coursePath(id), { method: "DELETE" }),
    removeSession: (id, k) => request(`${coursePath(id)}/session/${k}`, { method: "DELETE" }),
    create: (fields) => request("course", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ ...fields, model }),
    }),
  };
}
